import { Controller } from "stimulus"

export default class extends Controller {
  static get targets() {
    return ['template'];
  }

  updateAmount(event) {
    var form = $(this.element).closest('form');
    var paymentRows = form.find('.payment-row');
    if (paymentRows.length == 1) {
      var total = _.sumBy(form.find('.or-total'), function(o) { return +$(o).val(); });
      paymentRows.find('.pm-amount').val(total);   
    }
  }
  addPaymentRow(event) {
    event.preventDefault();
    var contentText = this.templateTarget.innerHTML.replace(/TMPL_ID/g, new Date().valueOf());
    var content = $(contentText);
    var form = $(this.element).closest('form');
    var total = _.sumBy(form.find('.or-total'), function(o) { return +$(o).val(); });
    var totalPayments = _.sumBy($(this.element).find('.pm-amount'), function(o) { return +$(o).val(); });
    
    var totalToPay = total - totalPayments;
    if (totalToPay>0) {
      content.find('.pm-amount').val(totalToPay);      
    }
    $(this.data.get("rowsElement")).append(content); 

    content.find('.datepicker').datetimepicker({
      format: 'L',
      locale: 'it'
    });

    content.find('.datetimepicker').datetimepicker({
        locale: 'it'
    });

    content.find('.pm-method-id').focus();
  }
}